import React from "react";

export const SiMessage: React.FC<{ type: string }> = ({ type, children }) => {
  return (
    <div className={`message flash-${type}`}>
      <span>{children}</span>
    </div>
  );
};
